<mat-card [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>
      <h2 class="panel-header">Få besked pr.</h2>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <mat-button-toggle-group #messageTypeGroup id="message-type-group" formControlName="type" color="primary">
      @if (indstillinger.typer.sms) {
        <mat-button-toggle [value]="2"> SMS </mat-button-toggle>
      }
      @if (indstillinger.typer.mail) {
        <mat-button-toggle [value]="3"> Mail </mat-button-toggle>
      }
    </mat-button-toggle-group>

    <div>
      @if (formGroup.get('type').value === type.sms) {
        <mat-form-field>
          <input
            matInput
            type="tel"
            placeholder="Mobilnummer"
            formControlName="mobil"
            id="qa-forbrugsoveraagning-faa-besked-sms-input"
            />
            <mat-error>Indtast dit mobilnummer</mat-error>
          </mat-form-field>
        }
        @if (formGroup.get('type').value === type.mail) {
          <mat-form-field>
            <input
              matInput
              type="email"
              placeholder="E-mail"
              formControlName="mail"
              id="qa-forbrugsoveraagning-faa-besked-mail-input"
              />
              <mat-error>Indtast en gyldig mail-adresse</mat-error>
            </mat-form-field>
          }
        </div>
      </mat-card-content>
    </mat-card>
    @if (indstillinger.intervaller.daglig || indstillinger.intervaller.ugentlig || indstillinger.intervaller.maanedlig) {
      <mat-card
        [formGroup]="formGroup"
        >
        <mat-card-header>
          <mat-card-title>
            <h2 class="panel-header">Vælg hvor ofte du vil have besked</h2>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-button-toggle-group #messagePickerGroup id="message-picker-group" formControlName="frekvens" color="primary">
            @if (indstillinger.intervaller.daglig) {
              <mat-button-toggle [value]="1"> Daglig </mat-button-toggle>
            }
            @if (indstillinger.intervaller.ugentlig) {
              <mat-button-toggle [value]="2"> Ugentlig </mat-button-toggle>
            }
            @if (indstillinger.intervaller.maanedlig) {
              <mat-button-toggle [value]="3"> Månedlig </mat-button-toggle>
            }
          </mat-button-toggle-group>
        </mat-card-content>
      </mat-card>
    }
